import { request } from '@/utils/ajax';
import { memoize } from 'lodash-es';

export interface Currency {
    id: number;
    code: string;
    name: string;
}

export const getCurrencies = memoize(
    (): Promise<Currency[]> => {
        return request(`api/currency`).then((x) => x.json());
    }
);
